import { createApp } from "vue";
import SpnStudentCount from "./components/SpnStudentCount.vue";
import { getMountElements, readPayload, VUE_MOUNTED_ATTRIBUTE } from "./utils/vueMount";

const MOUNT_SELECTOR = "[data-vue-spn-student-count]";

export function initSpnStudentCountApp(root = document) {
  const apps = [];

  for (const element of getMountElements(root, MOUNT_SELECTOR)) {
    if (element.hasAttribute(VUE_MOUNTED_ATTRIBUTE)) {
      continue;
    }

    const payload = readPayload(element);
    const app = createApp(SpnStudentCount, {
      apiUrl: payload.apiUrl || "",
      batchApiUrl: payload.batchApiUrl || "",
      spnId: Number.parseInt(String(payload.spnId || "0"), 10) || 0,
      includeCompatibility: payload.includeCompatibility === true,
      studentsUrl: payload.studentsUrl || "",
      modalTitle: payload.modalTitle || "Lista uczniów",
      modalSubtitle: payload.modalSubtitle || "",
    });

    app.mount(element);
    element.setAttribute(VUE_MOUNTED_ATTRIBUTE, "1");
    apps.push(app);
  }

  return apps;
}
